import { IAutocompleteItem, MeasureTypes, MenuCategoryTypes, OrderTypes, TimeUnitTypes } from "./componentTypes";
import { IMenuItemOption } from "./request-interfaces";
import { IDeliveryCity, IDineInConfig } from "./responseTypes";

export interface ILoginFormValues {
  username: string;
  password: string;
};

export interface ISignUpFormValues {
  username: string,
  email: string,
  password: string,
  phone_number: string,
  verifyCode: string
};

export interface IEditUserForm {
  first_name: string,
  last_name: string,
  phone_number: string,
};

export interface ICreateBusinessForm {
  name: string,
  country: string,
  city: string,
  customer_count: IAutocompleteItem,
};

export interface ICreateBUsinessProfileForm {
  name: string,
  country: string,
  city: string,
  customer_count: IAutocompleteItem,
  address?: string,
  free_days?: IAutocompleteItem[],
  start_time: Date | null,
  end_time: Date | null,
};

export interface ICreateCategoryForm {
  name: string,
  menu_type: IAutocompleteItem,
  default_image: string,
  company_id: number,
  name_hy: string,
  name_en: string,
  name_ru: string
};

export interface IStaffMemberForm {
  first_name: string,
  last_name: string,
  user_role: IAutocompleteItem,
  phone_number: string,
  photo?: string,
  user_name: string,
  password: string
}



export interface IMenuItemFormOption {
  measure_type?: IAutocompleteItem,
  measure_value?: string,
  package_cost?: string,
  price?: string,
  is_active: boolean,
  option_id?: number,
}

export interface ICreateMenuItemForm {
  name?: string,
  description?: string,
  option: IMenuItemFormOption[],
  cooking_time?: string,
  cooking_time_unit?: IAutocompleteItem,
  category?: IAutocompleteItem,
  name_hy: string,
  name_en: string,
  name_ru: string,
  description_hy?: string,
  description_en?: string,
  description_ru?: string
}

export interface IEditMenuItemForm {
  option: IMenuItemFormOption[],
  cooking_time?: string,
  cooking_time_unit?: IAutocompleteItem,
  name_hy: string,
  name_en: string,
  name_ru: string,
  description_hy?: string,
  description_en?: string,
  description_ru?: string
}

export interface IUpdateCreatedCategoryForm {
  name_en: string,
  name_ru: string,
  name_hy: string,
  menu_type: IAutocompleteItem,
  default_image: string,
  category_id: number
}

export interface IFinancesForm {
  cost_currency: IAutocompleteItem,
  service_fee: string,
  pos_terminal: boolean,
}

export interface IProfileContactsForm {
  phone_numbers: { id: string, value: string }[],
  facebook?: string,
  twitter?: string,
  instagram?: string,
  telegram?: string,
  whatsapp?: string,
  viber?: string
}

export interface IMyServicesForm {
  delivery: {
    min_cost: null | number, // Keep for backward compatibility
    is_active: boolean,
    cities?: IDeliveryCity[];
  },
  pre_order: boolean,
  reserve: boolean;
  dine_in: IDineInConfig;
}

export interface IOrderDeliveryForm {
  city: string,
  region?: string,
  address: string,
  phone_number: string,
  date?: string,
  time?: Date,
  notes?: string,
  cash: boolean,
  card: boolean,
}

export interface ITableReserveForm {
  phone_number: string,
  date: string,
  time: Date,
  persons_count: string,
  notes?: string,
  pre_order?: boolean,
  dine_in: boolean,
  cash: boolean,
  card: boolean,
}

export interface IPreOrderForm {
  phone_number: string,
  date: string,
  time: Date,
  notes?: string,
  cash: boolean,
  card: boolean,
}

export interface IDineInOrderForm {
  phone_number: string,
  date?: string,
  time?: Date,
  notes?: string,
  cash: boolean,
  card: boolean,
}

export enum OrderStatus {
  NEW = "new",
  PENDING = "pending",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  IN_PREPARATION = "in_preparation",
  READY_FOR_PICKUP = "ready_for_pickup",
  OUT_FOR_DELIVERY = "out_for_delivery",
  DELIVERED = "delivered",
  CANCELLED = "cancelled",
}

export interface IOrder {
  companyId: number,
  phone_number: string,
  uuid: string,
  data: JSON,
  status: OrderStatus
}

export interface ICompnayOrders {
  new_orders: IOrder[] | [],
  my_orders: IOrder[] | [],
  rejected_orders: IOrder[] | [],
  cancelled_orders: IOrder[] | []
}

export interface IFilteredOrdersForm {
  order_id?: string;
  start_date?: string;
  end_date?: string;
  order_type?: IAutocompleteItem;
  order_status?: IAutocompleteItem;
  location_type?: IAutocompleteItem;
  location_number?: string;
}




